import { TokenExpired } from 'components/tokenExpired';

import { useCanAccess } from 'hooks';
import { Settings } from 'pages/settings';

export const SettingsManagementRoute = () => {
  const { isExpired } = useCanAccess('settings');
  return isExpired ? <TokenExpired /> : <Settings />;
};
